export default {
    INIT_FABRIC: 'INIT_FABRIC',
    UPDATE_FABRIC: 'UPDATE_FABRIC',
    ENABLE_TOOL: 'ENABLE_TOOL',
    SELECT_TOOL: 'SELECT_TOOL',
    ELLIPSE: 'ELLIPSE',
    RECTANGLE: 'RECTANGLE',
    FILLED_RECTANGLE: 'FILLED_RECTANGLE',
    DOTTED_RECTANGLE: 'DOTTED_RECTANGLE',
    LINE: 'LINE',
    DOTTED_LINE: 'DOTTED_LINE',
    ARROW: 'ARROW',
    TEXT_BOX: 'TEXT_BOX',
    TEXT_BOX_BORDER: 'TEXT_BOX_BORDER',
    ANNOTATION: 'ANNOTATION',
    IMAGE: 'IMAGE',
    MEASUREMENT: 'MEASUREMENT',
    DISABLE_TOOL: 'DISABLE_TOOL',
    DELETE_OBJECT: 'DELETE_OBJECT',
    SAVE_DRAWING: 'SAVE_DRAWING',
    SAVE_DRAWING_SUCCESS: 'SAVE_DRAWING_SUCCESS',
    SAVE_DRAWING_FAIL: 'SAVE_DRAWING_FAIL',
    ZOOM_IN: 'ZOOM_IN',
    ZOOM_OUT: 'ZOOM_OUT',
    RESET_ZOOM: 'RESET_ZOOM',
    EXPORT_DRAWING: 'EXPORT_DRAWING',
    EXPORT_DRAWING_SUCCESS: 'EXPORT_DRAWING_SUCCESS',
    EXPORT_DRAWING_FAIL: 'EXPORT_DRAWING_FAIL',
    EXPORT_DRAWING_INPROGRESS: 'EXPORT_DRAWING_INPROGRESS',
    SET_PAGE_DETAILS: 'SET_PAGE_DETAILS',
    REVIEW_PAGE: 'REVIEW_PAGE',
    REVIEW_PAGE_SUCCESS: 'REVIEW_PAGE_SUCCESS',
    GET_PAGES: 'GET_PAGES',
    GET_PAGES_SUCCESS: 'GET_PAGES_SUCCESS',
    PREVIEW_DRAWING: 'PREVIEW_DRAWING',
    PREVIEW_DRAWING_SUCCESS: 'PREVIEW_DRAWING_SUCCESS',
    PREVIEW_DRAWING_FAIL: 'PREVIEW_DRAWING_FAIL',
    SET_PAGE_DATA: 'SET_PAGE_DATA',
    SET_DRAWING_DATA: 'SET_DRAWING_DATA',
    SET_DRAWING_DATA_SUCCESS: 'SET_DRAWING_DATA_SUCCESS',
    SET_DRAWING_DATA_FAIL: 'SET_DRAWING_DATA_FAIL',
    CREATE_NEW_PAGE: 'CREATE_NEW_PAGE',
    HANDLE_DROP: "HANDLE_DROP",
    GET_PROJECT: 'GET_PROJECT',
    GET_PROJECT_SUCCESS: 'GET_PROJECT_SUCCESS',
    GET_PLAN_OVERVIEW: 'GET_PLAN_OVERVIEW',
    GET_PROJECT_FAILURE: 'GET_PROJECT_FAILURE',
    GET_PLAN_OVERVIEW_FAILURE: 'GET_PLAN_OVERVIEW_FAILURE',
    GET_ROOM_INFO_LIST: 'GET_ROOM_INFO_LIST',
    SET_PAGE_NOTES: 'SET_PAGE_NOTES',
    SET_CUSTOMER_DETAILS: 'SET_CUSTOMER_DETAILS',
    SET_ROOM_NOTES: 'SET_ROOM_NOTES',
    EXPORT_FINAL_PDF: 'EXPORT_FINAL_PDF',
    EXPORT_FINAL_PDF_SUCCESS: 'EXPORT_FINAL_PDF_SUCCESS',
    EXPORT_FINAL_PDF_FAIL: 'EXPORT_FINAL_PDF_FAIL',
    SET_PROJECT_FAILURE: 'SET_PROJECT_FAILURE',
    SET_ROOM_NAME: 'SET_ROOM_NAME',
    CREATE_PAGE_COPY: 'CREATE_PAGE_COPY',
    UPLOAD_DRAWING: 'UPLOAD_DRAWING',
    UPLOAD_DRAWING_SUCCESS: 'UPLOAD_DRAWING_SUCCESS',
    UPLOAD_DRAWING_FAIL: 'UPLOAD_DRAWING_FAIL',
    REMOVE_PAGE: 'REMOVE_PAGE',
    SET_FLOORS_DATA: 'SET_FLOORS_DATA',
    SAVE_PAGE_FIELDS: 'SAVE_PAGE_FIELDS',
    UPLOAD_IMAGE: 'UPLOAD_IMAGE',
    REMOVE_IMAGE: 'REMOVE_IMAGE',
    GET_TAG_IMAGES: 'GET_TAG_IMAGES',
    PAGE_LOADING_STATUS: 'PAGE_LOADING_STATUS',
    COPY_SELECTED_DRAWING: 'COPY_SELECTED_DRAWING',
    PASTE_SELECTED_DRAWING: 'PASTE_SELECTED_DRAWING',
    ADD_IMAGE: 'ADD_IMAGE',
    IMAGE_DATA: 'IMAGE_DATA',
    DQC_DETAILS: 'DQC_DETAILS',
    UPLOAD_DQC_DATA: 'UPLOAD_DQC_DATA',
    UPDATE_DQC_DATA: 'UPDATE_DQC_DATA',
    IMAGEDROPDOWN:'IMAGEDROPDOWN',
    LOCAL_IMAGE:'LOCAL_IMAGE',
    SPACECRAFT_IMAGE:'SPACECRAFT_IMAGE',
    OPEN_GALLERY:'OPEN_GALLERY',
    SET_ROOM_IMAGES:'SET_ROOM_IMAGES',
    TEXT_SELECTED: 'TEXT_SELECTED',
    CURVE:'CURVE',
    DOTTED_CURVE:'DOTTED_CURVE',
    SELECTED_OBJECT:'SELECTED_OBJECT',
    ORDER_PROFILE_TYPE:'ORDER_PROFILE_TYPE',
    UNDO:'UNDO',
    REDO:'REDO',
    GROUPING:'GROUPING',
    ENABLE_LAYERING:'ENABLE_LAYERING',
    GET_ROSTER_TOKEN: 'GET_ROSTER_TOKEN',
    SAVE_UPDATED_PAGE_DETAILS: 'SAVE_UPDATED_PAGE_DETAILS',
    EXPAND_COLLAPSE_SIDEBAR_MENU: 'EXPAND_COLLAPSE_SIDEBAR_MENU',
    REQUIRED_META_DATA_UPDATE: 'REQUIRED_META_DATA_UPDATE',
    CROP_IMAGE: 'CROP_IMAGE',
    SAVE_CROP_IMAGE_DETAILS: 'SAVE_CROP_IMAGE_DETAILS',
    SHOW_CREATION_TABLE_MODAL: 'SHOW_CREATION_TABLE_MODAL',
    CROP_SELECTED_IMAGE: 'CROP_SELECTED_IMAGE',
    PAINT_FORMATTING_ENABLE: 'PAINT_FORMATTING_ENABLE',
    UPLOADING_IMAGES: 'UPLOADING_IMAGES',
    ORDER_PROFILE_TITTLE:'ORDER_PROFILE_TITTLE',
} 